import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AlertNotice, Input } from 'shared/components/';
import Range from './Range';
import MaterialIcon from 'material-icons-react';
import { filter, sumBy } from 'lodash';

import './MaterialRanges.scss';

const MaterialRanges = ({
  materialType,
  materialsRanges,
  handleAdd,
  handleRemove,
  handleChange,
  handleLeadingZero,
  handleCheck,
  parentRanges,
  roomClosed,
  materialTypeNotMatch,
  showRemoveBtn,
  errors,
  eventRange,
}) => {
  const { t } = useTranslation();
  const hideMaterialsBox = (!materialsRanges || !materialsRanges.length) && eventRange;

  return (
    <div className="material-ranges">
      <div className="material-title">
        {handleCheck ? (
          <Input
            type="checkbox"
            name={`material-${materialType.id}`}
            id={`checkMaterial-${materialType.id}`}
            value={materialType.id}
            onChange={handleCheck}
            checked={materialsRanges && materialsRanges.length ? true : false}
            required>
            <label htmlFor={`checkMaterial-${materialType.id}`}>
              {materialType.name} ({sumBy(materialsRanges, 'count') || 0})
            </label>
          </Input>
        ) : (
          <label>
            {materialType.name} ({sumBy(materialsRanges, 'count') || 0})
          </label>
        )}
      </div>

      {filter(errors, { type: 'materialType' }).map((error, index) => (
        <AlertNotice message={t(error.message)} type="error" key={index} />
      ))}

      {materialTypeNotMatch && (
        <AlertNotice
          message={t('testCenter.testMaterialsRanges.warningRoomTypeNotMatch')}
          type="warning"
        />
      )}

      {!hideMaterialsBox && (
        <div className="border-box-silver">
          {parentRanges && (
            <div className="parent-ranges">
              <div>
                {t('testCenter.testMaterialsRanges.roomEventRangesMessage', {
                  name: materialType.name,
                })}
              </div>
              {parentRanges.map((range, index) => (
                <span key={index}>
                  {range.rangeBegin} - {range.rangeEnd}
                </span>
              ))}
            </div>
          )}
          {materialsRanges && !!materialsRanges.length && (
            <React.Fragment>
              {eventRange && (
                <AlertNotice message={t('testCenter.testMaterialsRanges.testRangesInfoMessage')} />
              )}
              <div className="one-booklet-info">
                <i className="fa fa-info-circle" />
                {t('testCenter.testMaterialsRanges.oneBookletMessage')}
              </div>
              <div className="material-range header">
                <div className="range">
                  <div>
                    {t('testCenter.testMaterialsRanges.rangesLabel')} - {materialType.name}{' '}
                  </div>
                  {t('testCenter.testMaterialsRanges.serialNumberLabel')}
                </div>
                <div className="total">
                  <div>{t('testCenter.testMaterialsRanges.totalBookletsLabel')}</div>
                  {t('testCenter.testMaterialsRanges.perRangeLabel')}
                </div>
                <div className="actions"></div>
              </div>
            </React.Fragment>
          )}

          {materialsRanges?.map((range, index) => (
            <Range
              key={`range-${index}`}
              materialType={materialType}
              handleRemove={handleRemove}
              handleChange={handleChange}
              handleLeadingZero={handleLeadingZero}
              index={index}
              showRemoveBtn={showRemoveBtn || materialsRanges.length > 1 || materialTypeNotMatch}
              errors={errors && filter(errors, { index })}
              roomClosed={roomClosed}
              {...range}
            />
          ))}

          <button
            className="pl-0 btn-link text-pacific-blue text-strong add-button"
            onClick={() => handleAdd(materialType.id)}>
            <span className="fw-bold">
              <MaterialIcon icon="control_point" size="tiny" />
              {t('testCenter.testMaterialsRanges.addRangeLabel')}
            </span>
          </button>
        </div>
      )}
    </div>
  );
};

MaterialRanges.propTypes = {
  materialType: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
  materialsRanges: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.number,
    })
  ),
  handleRemove: PropTypes.func,
  handleChange: PropTypes.func,
  handleLeadingZero: PropTypes.func,
  handleCheck: PropTypes.func,
  checkedMaterials: PropTypes.arrayOf(PropTypes.number),
  parentRanges: PropTypes.arrayOf(PropTypes.shape({})),
  roomClosed: PropTypes.bool,
  materialTypeNotMatch: PropTypes.bool,
  showRemoveBtn: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.shape({})),
  eventRange: PropTypes.bool,
  handleAdd: PropTypes.func,
};

MaterialRanges.defaultProps = {
  materialTypeNotMatch: false,
  showRemoveBtn: false,
  eventRange: false,
};
export default MaterialRanges;
